export const ORGANIZATION_MEMBER_FIRST_NAMES: ReadonlyArray<string> = [
  'Aiden',
  'Sarah',
  'James',
  'Mia',
  'Noah',
  'Priya',
  'Liam',
  'Zanele',
  'Ethan',
  'Fatima',
  'Oliver',
  'Chloe',
  'Lucas',
  'Nadia',
  'Daniel',
  'Grace',
  'Omar',
  'Isla',
  'Kai',
  'Leila',
];

export const ORGANIZATION_MEMBER_LAST_NAMES: ReadonlyArray<string> = [
  'Hemmings',
  'Pillay',
  'Okoro',
  'Chen',
  'Naidoo',
  'Patel',
  'Botha',
  'Khan',
  'Mbeki',
  'Costa',
  'Nguyen',
  'Silva',
  'Adeyemi',
  'Rossi',
  'Dlamini',
  'Meyer',
  'Haddad',
  'Walsh',
  'Suzuki',
  'Farah',
];

export const ORGANIZATION_MEMBER_ROLES: ReadonlyArray<string> = [
  'Admin',
  'Manager',
  'Analyst',
  'Member',
  'Viewer',
];

export const ORGANIZATION_PAYMENT_METHODS: ReadonlyArray<string> = [
  'Invoice / Bank transfer',
  'Visa •••• 4242',
  'Mastercard •••• 5518',
  'Amex •••• 1007',
];
